/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import { unidadDeLinea, contenidoEmpaqueDeLinea } from "../../../../utils/unidades";
import { useParams, useLocation } from "react-router-dom";
import { request } from "../../../../utils/request";
import { formatCurrency, formatNumber, getSucursal } from "../../../../utils/helpers";
import dayjs from "dayjs";
import { apiRequest } from "../../../../hooks/apiRequest";
import QR from "../../Components/QR";

const tipos_impuesto = {
	itbis: "Itbis",
	otro: "Otro",
	isc: "ISC",
	propina_legal: "Propina",
	no_facturable: "No facturable",
	exento: "Exento",
};

const tiposComprobante = [
	"B01",
	"B02",
	"B14",
	"B15",
	"B16",
	"B11",
	"B03",
	"B11",
	"E31",
	"E32",
	"E44",
	"E45",
	"E46",
	"E47",
];

const searchParams = new URL(window.location).searchParams;
const isOriginal = searchParams.get("original") === "1";

const getDiasPlazo = (fecha, fecha_vencimiento) => {
	fecha = new Date(fecha);
	fecha_vencimiento = new Date(fecha_vencimiento);

	let difference = fecha.getTime() - fecha_vencimiento.getTime();
	let TotalDays = Math.ceil(difference / (1000 * 3600 * 24));
	return Math.abs(TotalDays);
};

const limitVendedorFullName = (name, lastName) => {
	name = name.split(" ");
	lastName = lastName.split(" ");

	return `${name[0]} ${lastName[0]}`;

	// if (name.length <= 2) return name.join(" ");

	// return name.slice(0, 3).join(" ");
};

// Determina el texto a mostrar como método de pago en la impresión (mobile).
// Si la factura fue pagada (total o parcialmente) con una nota de crédito,
// se indica "NOTA DE CREDITO" en lugar del tipo de pago por defecto.
const obtenerMetodoPagoDisplay = (factura) => {
	if (!factura) return "Efectivo";

	const metodos = obtenerMetodosPago(factura);

	if (metodos.length === 0) return "Efectivo";

	// Si todos son nota de crédito, mostrar ese texto
	if (metodos.every((m) => m.tipo_pago === "nota_credito")) {
		return "NOTA DE CREDITO";
	}

	return metodos
		.map((m) => {
			const label =
				m.tipo_pago === "nota_credito" ? "NOTA DE CREDITO" : m.tipo_pago;
			return `${label}`;
		})
		.join(" + ");
};

// Devuelve un array de métodos de pago únicos con el monto sumado por tipo.
// Usado en desktop para mostrar cada método de pago en su propia fila.
const obtenerMetodosPago = (factura) => {
	if (!factura) return [];

	const pagos =
		factura.pagos && Array.isArray(factura.pagos) ? factura.pagos : [];

	if (pagos.length === 0 && factura.tipo_pago) {
		return [{ tipo_pago: factura.tipo_pago, monto: factura.total || 0 }];
	}

	const agrupado = {};
	pagos.forEach((pago) => {
		const tipo = pago.tipo_pago || "efectivo";
		if (!agrupado[tipo]) {
			agrupado[tipo] = { tipo_pago: tipo, monto: 0 };
		}
		agrupado[tipo].monto += parseFloat(pago.monto) || 0;
	});

	return Object.values(agrupado);
};

const tipoITBIS = (impuesto) => {
	if (!impuesto) return "";
	if (impuesto.tipo === "itbis" && impuesto.porcentaje === 0.16) {
		return "I1";
	} else if (impuesto.tipo === "itbis" && impuesto.porcentaje === 0.18) {
		return "I2";
	} else if (impuesto.tipo === "itbis" && impuesto.porcentaje === 0) {
		return "IE";
	}
};

const calcularImpuestos = (productos) => {
	let impuestos = {};

	if (productos) {
		productos.forEach((producto) => {
			const nombreImpuesto = `${tipos_impuesto[producto.impuesto.tipo]} ${
				producto.impuesto.porcentaje * 100
			}%`;

			if (
				!tipos_impuesto[producto.impuesto?.tipo] ||
				producto.impuesto?.porcentaje === 0
			) {
				return;
			}

			if (isNaN(impuestos[nombreImpuesto])) {
				impuestos[nombreImpuesto] = 0;
			}

			impuestos[nombreImpuesto] +=
				producto.cantidad *
				(producto.importe * producto.impuesto?.porcentaje).toFixed(2);
		});
	}

	return impuestos;
};

const calcularExentoGrabado = (productos) => {
	let exentoGrabado = {};

	if (productos) {
		productos.forEach((producto) => {
			const nombreImpuesto =
				producto.impuesto.tipo === "exento" ? "Exento" : "Grabado";

			if (isNaN(exentoGrabado[nombreImpuesto])) {
				exentoGrabado[nombreImpuesto] = 0;
			}

			exentoGrabado[nombreImpuesto] +=
				producto.importe * producto.cantidad;
		});
	}

	return exentoGrabado;
};

const PrintSingleFacturaNew = () => {
	const { id } = useParams();
	const location = useLocation();

	const [factura, setFactura] = useState({
		productos: [],
	});
	const [sucursal, setSucursal] = useState({});
	const [isMobileDevice, setIsMobileDevice] = useState(false);

	const [sumatoriaFinal, setSumatoriaFinal] = useState({
		impuestos: {},
	});
	const [status, setStatus] = useState("Original");
	const [listo, setListo] = useState(false);

	const getFactura = () => {
		request("facturas/" + id).then((res) => {
			setFactura(res.data);
			setListo(true);
		});
	};

	const isFactura = (factura) => {
		return (
			factura.entidad === "factura" &&
			tiposComprobante.findIndex(
				(tipo) => tipo === factura.numero_comprobante.substring(0, 3)
			) >= 0
		);
	};

	const onChangeStatusFactura = (estado) => {
		setStatus(estado);
	};

	useEffect(() => {
		getFactura();
		const sucursalInfo = JSON.parse(localStorage.getItem("user"));
		setSucursal(
			sucursalInfo.sucursales.find(
				(sucursal) => sucursal.id === getSucursal()
			)
		);
		// window.addEventListener("afterprint", () => {
		// 	apiRequest(null, `facturas/${id}/update-printed`, "put");
		// });
		// identify if mobile
		let isMobile = navigator.userAgent.toLowerCase().match(/mobile/i),
			isTablet = navigator.userAgent.toLowerCase().match(/tablet/i),
			isAndroid = navigator.userAgent.toLowerCase().match(/android/i),
			isiPhone = navigator.userAgent.toLowerCase().match(/iphone/i),
			isiPad = navigator.userAgent.toLowerCase().match(/ipad/i);

		if (isMobile || isTablet || isAndroid || isiPhone || isiPad) {
			setIsMobileDevice(true);
		}
	}, []);
	useEffect(() => {
		setSumatoriaFinal((state) => ({
			...state,
			impuestos: calcularImpuestos(factura.productos),
			exentoGrabado: calcularExentoGrabado(factura.productos),
		}));

		// En movil nunca se ha marcado la factura como impresa desde aqui; se
		// mantiene ese comportamiento. Antes era un efecto colateral del calculo
		// de alturas que vivia encima de esta guarda y ya no existe.
		if (isMobileDevice) return;

		if (
			!!factura.id &&
			!factura.se_ha_impreso &&
			parseFloat(factura.descuentoExtra) > 0
		) {
			apiRequest(null, `facturas/${factura.id}/update-printed`, "PUT");
		}
	}, [factura]);

	// Espera a que el estado con los datos ya esté reflejado en el DOM
	// antes de abrir el diálogo de impresión.
	useEffect(() => {
		if (listo) {
            setTimeout(() => {
                window.print();
            }, 1000);
		}
	}, [listo]);

	let notas = factura.notas || "";
	if (!isOriginal) {
		if (factura.descuentoExtra > 0) {
			notas += ` -- Descuento por nota de crédito: ${formatCurrency(
				factura.descuentoExtra
			)}`;
		}
        if (notas.indexOf('PAGO') === -1 && factura.fecha_pago) {
            notas += `\n FECHA DE PAGO ${dayjs(factura.fecha_pago).format("DD/MM/YYYY")}`;
        }
	} else {
		let index = -1;
		if (isOriginal) {
			index = notas?.indexOf("Factura afectada");
			if (index > -1) {
				notas = notas.slice(0, index);
			}
			index = notas?.indexOf("FECHA DE PAGO");
			if (index > -1) {
				notas = notas.slice(0, index);
			}
		}
	}

	return (
		<>
			<FacturaTemplate
				factura={factura}
				sucursal={sucursal}
				sumatoriaFinal={sumatoriaFinal}
				isFactura={isFactura}
				status={status}
				isMobileDevice={isMobileDevice}
				notas={notas}
			/>
			{/* Segunda factura (Se usa en las facturas dobles) */}
			{location.pathname.includes("doble") && (
				<>
					<div
						style={{ borderTop: "2px dashed #000" }}
						className="my-4"
					></div>
					<FacturaTemplate
						factura={factura}
						sucursal={sucursal}
						sumatoriaFinal={sumatoriaFinal}
						isFactura={isFactura}
						status={status}
						isMobileDevice={isMobileDevice}
						notas={notas}
					/>
				</>
			)}
			<div className="ordernar-resultados no-print">
				<div className="form-group">
					<div className="radio-btn">
						<label>
							<input
								type="radio"
								onChange={() =>
									onChangeStatusFactura("Original")
								}
								name="orden"
								value="Original"
								defaultChecked={true}
							/>{" "}
							Original
						</label>
						<label>
							<input
								type="radio"
								onChange={() => onChangeStatusFactura("Copia")}
								name="orden"
								value="Copia"
							/>{" "}
							Copia
						</label>
					</div>
				</div>
			</div>
		</>
	);
};

export const FacturaTemplate = ({
	factura,
	sucursal,
	sumatoriaFinal,
	isFactura = () => false,
	status = "",
	isMobileDevice = false,
	notas = "",
}) => {

    const totalImpuestos = Object.keys(sumatoriaFinal.impuestos).reduce(
        (a, i) =>
            a +
            parseFloat(sumatoriaFinal.impuestos[i]),
        0
    );

	return (
		<>
            <MobileLayout
                factura={factura}
                sucursal={sucursal}
                sumatoriaFinal={sumatoriaFinal}
                status={status}
                notas={notas}
                totalImpuestos={totalImpuestos}
            />
            <DesktopLayout
                factura={factura}
                sucursal={sucursal}
                sumatoriaFinal={sumatoriaFinal}
                status={status}
                notas={notas}
                totalImpuestos={totalImpuestos}
            />
		</>
	);
};

const MobileLayout = ({
	factura,
	sucursal,
	sumatoriaFinal,
	isFactura = () => false,
	status,
	notas = "",
    direccion_entrega,
    totalImpuestos,
}) => {
	return (
		<>
			<style>
				{`
                    @import url('https://fonts.googleapis.com/css2?family=Saira+Extra+Condensed:wght@400;700&display=swap');

                    .invoice-mobile {
                        display: none
                    }

                    body {
                        font-family: "Saira Extra Condensed", sans-serif !important;
                        width: 100% !important;
                        font-size: 12pt !important;
                    }

                    @media print {
                        body {
                            min-width: auto !important;
                        }
                    }

					@media(max-width: 450px){
                        @page {
                            size: 80mm 300mm !important;
                            margin-top: 0 !important;
                            margin-bottom: 0 !important;
                            margin-left: 20px !important;
                            margin-right: 20px !important;
                        }
                        .invoice {
                            width: 100% !important;
                            padding: 0 20px 0 5px;
                        }
                        .invoice small {
                            font-size: 10pt;
                            line-height: 1;
                        }
                        .invoice-table {
                            display: none;
                        }
                        .sm-invoice-table {
                            display: block;
                        }
                        .invoice h3 {
                            margin-bottom: 0.1rem;
                        }
                        .invoice h3.signature-title {
                            font-weight: 600 !important;
                        }
                        .client-info-title {
                            font-weight: 600 !important;
                        }
                        .info-cliente-responsive .info-client__response {
                            line-height: 1.2 !important;
                        }
                        .invoice-name {
                            font-weight: 600 !important;
                        }
                        .info-cliente-responsive {
                            line-height: 1.2 !important;
                            margin-bottom: 5px !important;
                        }
                        .info-cliente-responsive .row{
                            margin-bottom: 6px;
                        }
                        .invoice-mobile {
                            display: block;
                            width: 100% !important;
                        }
                        hr {
                            margin: 5px 0;
                        }
                        .sucursal-name {
                            font-size: 14pt;
                        }
                        .detalles-sucursal {
                            line-height: 1;
                            margin-bottom: 10px;
                        }
                        .top-info {
                            line-height: 1;
                        }
    					.sucursal-name-sm {
    					    display:block;
    					}
                        .producto-item {
                            font-size: 10pt;
                        }
    					.factura-logo{
    					    display:none;
    					}
    					.sucursal-name-lg{
    					    display:none;
    					}
						.info-cliente-responsive .row {
							margin-bottom: 0 !important;
						}
                        .client-info-title {
                            min-width: 90px;
                        }
                        .tabla-titulos small {
                            font-weight: 600;
                        }
                        .totales {
                            line-height: 1.2;
                            margin-bottom: 10px;
                        }
						.summary-text{
							// max-width:39% !important;
							width:auto !important;
							flex:auto;
							padding-left: 5px !important;
							padding-right: 2px !important;
						}
                        .justify-content-between {
							justify-content: flex-end !important;
						}
						.justify-content-between :nth-child(2){
							max-width: 33% !important;
						}
					}
				`}
			</style>
			<div className="invoice invoice-mobile recibo-print">
				<div className="clear-both p-t-30 p-b-10">
					<div>
						<h3 className="sucursal-name text-center">{sucursal.nombre}</h3>
						<div
							className="text-center detalles-sucursal"
						>
							RNC: {sucursal.rnc} TEL.:{sucursal.telefono}<br />
                            {sucursal.direccion}
						</div>
					</div>

					<div className="">
						<div
							className="mb-1 d-block"
						>
							<div className="d-flex top-info fechaSpace">
								<div className="d-block">
									{getDiasPlazo(
										factura.fecha,
										factura.fecha_vencimiento
									) > 0 ? (
										<>
											<span>
												{getDiasPlazo(
													factura.fecha,
													factura.fecha_vencimiento
												) || 0}{" "}
												días
											</span>
											<br />
										</>
									) : (
										<>
											<span>{factura.plazo?.nombre || 'CONTADO'}</span>
											<br />
										</>
									)}

									{factura.estado === "pagada" && (
										<span>
											<span className="text-capitalize">
												{obtenerMetodoPagoDisplay(factura)}
											</span>
										</span>
									)}
									{factura.tipo === "contado" &&
									factura.estado === "pendiente" ? (
										<span>Pendiente</span>
									) : (
										factura.tipo === "contado" &&
										factura.estado === "cancelada" && (
											<span>Cancelada</span>
										)
									)}
                                    <span className="d-block client-info-title pt-2">
                                        {status}
                                    </span>
								</div>

								<div className="d-block text-right">
									Fecha:{" "}
									{dayjs(factura.fecha).format("DD/MM/YYYY")}
									<br />
									<span>
										{factura.entidad === "factura" &&
										!factura.numeracion?.isProforma
											? "NCF: "
											: "NO. "}
									</span>
									{!factura.numeracion?.isProforma ? factura.numero_comprobante : `OC${factura.numero_comprobante.substring(factura.numero_comprobante.length - 5)}`}
									{factura.numeracion?.fecha_vencimiento && (
										<div>
                                            <small>
                                                <span>FV:</span>{" "}
                                                {dayjs(
                                                    factura.numeracion
                                                        ?.fecha_vencimiento
                                                ).format("DD/MM/YYYY")}
                                            </small>
                                        </div>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>

				<div className="info-cliente-responsive d-block">
					{factura.cliente && (
						<div className="d-flex">
                            <div className="client-info-title">
                                Cliente:
                            </div>
                            <div>{factura.cliente?.codigo} - {factura.cliente?.nombre}</div>
						</div>
					)}
					{factura.cliente?.identificacion && (
						<div className="d-flex">
							<div className="client-info-title">
								RNC/Cédula:
							</div>
                            <div>{factura.cliente?.identificacion}</div>
						</div>
					)}
					{factura.cliente?.encargado && (
						<div className="d-flex">
							<div className="client-info-title">
								Responsable:
							</div>
                            <div>{factura.cliente?.encargado}</div>
						</div>
					)}
					{factura.cliente?.telefono && (
						<div className="d-flex">
							<div className="client-info-title">
								Teléfono:
							</div>
                            <div>{factura.cliente?.telefono}</div>
						</div>
					)}
					{factura.cliente?.direcciones && factura.cliente?.direcciones?.length > 0 && (
						<div className="d-flex">
							<div className="client-info-title">
								Dirección:
							</div>
                            <div>{factura.cliente?.direcciones[0].direccion}</div>
						</div>
					)}

					{factura.vendedor?.nombre && (
						<div className="d-flex">
							<div className="client-info-title">
								Vendedor:
							</div>
                            <div>
                                {limitVendedorFullName(
                                    factura.vendedor?.nombre,
                                    factura.vendedor?.apellido
                                )}
                            </div>
						</div>
					)}
				</div>

				<hr style={{borderStyle: 'dashed', borderWidth: '1px', margin: '0'}} />
                <div
                    className="d-block bold tipo-factura text-center uppercase"
                >
                    {factura.numeracion?.isProforma
                        ? "Orden de Compra"
                        : factura.numeracion?.nombre}
                </div>
				<hr style={{borderStyle: 'dashed', borderWidth: '1px', margin: '0'}} />

				{/* PRODUCTOS RESPONSIVE */}
				<div>
					<div className="row tabla-titulos" style={{ fontWeight: "600" }}>
						<div className="col-5">
                            <small>DESCRIPCIÓN</small>
                        </div>
						<div className="col-3 text-right" style={{paddingRight: '5px'}}>
                            <small>ITBIS</small>
                        </div>
						<div className="col-4 text-right" style={{ whiteSpace: "nowrap" }}>
							<small>TOTAL</small>
						</div>
					</div>

                    <hr style={{borderStyle: 'dashed', borderWidth: '1px', margin: '0 0 5px'}} />

					{factura.productos?.map((producto) => {
                        const descuento = producto.importe * producto.descuento / 100;
                        const impuestos = (producto.precio_facturado - producto.importe) * producto.cantidad;
                        // Facturado por empaque: cuánto trae ese empaque, junto al nombre.
                        const contenidoEmpaque = contenidoEmpaqueDeLinea(producto);
						return (
							<div
								className="row producto-item align-items-end"
								style={{
									marginBottom: "5px",
								}}
								key={producto.id}
							>
								<div
									className="col-5"
									style={{ lineHeight: "1" }}
								>
									{`${producto.cantidad} x ${formatCurrency(
										producto.precio_facturado - descuento,
										""
									)}`}
									<br />
                                    REF: {producto.producto?.referencia}
									<br />
                                    {producto.producto.tipo === 'grupo' && producto.producto.componentes && (
                                        <>
                                            {producto.producto.componentes.map(componente => (
                                                <small className="d-block text-muted">
                                                    {componente.cantidad} - {componente.componente.nombre}
                                                </small>
                                            ))}
                                        </>
                                    )}
									{producto.producto?.nombre}
                                    {contenidoEmpaque && ` (${contenidoEmpaque})`}
                                    {descuento > 0 && (
                                        <div>DESCUENTO</div>
                                    )}
								</div>
								<div className="col-3 text-right" style={{paddingRight: '5px', lineHeight: 1.1}}>
									{Object.keys(sumatoriaFinal.impuestos)
										.length > 1 && (
										<span className="fw-600">
											{tipoITBIS(producto.impuesto)}{" "}
										</span>
									)}
									{formatNumber(impuestos)}
                                    {descuento && (
                                        <div>-{formatNumber(impuestos * producto.descuento / 100)}</div>
                                    )}
								</div>
								<div className="col-4 text-right" style={{lineHeight: 1.1}}>
									{formatNumber(producto.total - (descuento * producto.cantidad))}{" "}
                                    {descuento && (
                                        <div>-{formatNumber(descuento * producto.cantidad)}</div>
                                    )}
								</div>
							</div>
						);
					})}
				</div>

                <hr className="mt-2" style={{borderStyle: 'dashed', borderWidth: '1px'}} />

				<div className="totales">
					{factura.descuento > 0 && (
						<div className="row justify-content-between">
							<div
								className="col"
								style={{
									fontWeight: "600",
								}}
							>
								Descuento Total
							</div>
							<div
								className="col-4 text-right"
							>
								-{formatNumber(factura.descuento)}
							</div>
						</div>
					)}
					<div className="row justify-content-between justify-content-md-end">
						<div
							className="col"
							style={{
								fontWeight: "600",
							}}
						>
							Subtotal
						</div>
						<div
							className="col-4 text-right"
						>
							{formatNumber(factura.subtotal)}
						</div>
					</div>
					{sumatoriaFinal?.exentoGrabado?.Exento &&
						Object.keys(sumatoriaFinal.exentoGrabado).map(
							(impuesto, index) => {
								return (
									<div
										className="row justify-content-between"
										key={index}
									>
										<div
											className="col"
											style={{
												fontWeight: "600",
											}}
										>
											{impuesto}
										</div>
										<div
											className="col-4 text-right"
										>
											{formatNumber(
												sumatoriaFinal
													.exentoGrabado[impuesto]
											)}
										</div>
									</div>
								);
							}
						)}
					{Object.keys(sumatoriaFinal.impuestos).map(
						(impuesto, index) => {
							return (
								<div
									className="row justify-content-between"
									key={index}
								>
									<div
										className="col"
										style={{
											fontWeight: "600",
										}}
									>
										{impuesto}
									</div>
									<div
										className="col-4 text-right"
									>
										{formatNumber(
											factura.sumatoria ? factura.sumatoria[impuesto.toUpperCase()] : sumatoriaFinal.impuestos[impuesto]
										)}
									</div>
								</div>
							);
						}
					)}
                    {Object.keys(sumatoriaFinal.impuestos).length > 1 && (
                        <div className="row justify-content-between mb-1">
                            <div
                                className="col"
                                style={{
                                    fontWeight: "600",
                                }}
                            >
                                Total Impuestos
                            </div>
                            <div
                                className="col-4 text-right"
                            >
                                {formatCurrency(
                                    Object.keys(
                                        sumatoriaFinal.impuestos
                                    ).reduce(
                                        (a, i) =>
                                            a +
                                            parseFloat(
                                                sumatoriaFinal.impuestos[i]
                                            ),
                                        0
                                    )
                                )}
                            </div>
                        </div>
                    )}
					{!isOriginal &&
						factura.descuentoExtra > 0 &&
						!factura.se_ha_impreso && (
							<div className="row justify-content-between">
								<div
									className="col"
									style={{
										fontWeight: "600",
									}}
								>
									Descuento Nota de Crédito
								</div>
								<div
									className="col-4 text-right"
									style={{
										maxWidth: "9rem",
									}}
								>
									{formatNumber(factura.descuentoExtra)}
								</div>
							</div>
						)}

					<div className="row justify-content-between">
						<div
							className="col"
							style={{
								fontWeight: "600",
							}}
						>
							TOTAL A PAGAR
						</div>
						<div
							className="col-4 text-right"
						>
							{formatNumber(factura.total)}
						</div>
					</div>
					{Object.keys(sumatoriaFinal.impuestos).length > 1 && (
						<hr className="mb-0" />
					)}

					<div className="invoice-itbis-info text-center">
						{Object.keys(sumatoriaFinal.impuestos).length > 1 && (
							<p
								style={{
									fontSize: "small",
								}}
							>
								{Object.keys(sumatoriaFinal.impuestos).includes(
									"Itbis 16%"
								) && (
									<>
										<span>
											Items con I1 son gravados con 16%
											ITBIS
										</span>
										<br />
									</>
								)}
								{Object.keys(sumatoriaFinal.impuestos).includes(
									"Itbis 18%"
								) && (
									<span>
										Items con I2 son gravados con 18% ITBIS
									</span>
								)}
							</p>
						)}
{/*
						{Object.keys(sumatoriaFinal.impuestos).length > 1 && (
							<div className="row justify-content-between">
								<div
									className="col-6 pr-1"
									style={{
										maxWidth: "11rem",
										fontSize: "small",
										fontWeight: "600",
										whiteSpace: "nowrap",
									}}
								>
									TOTAL IMPUESTOS
								</div>
								<div
									className="col-4 text-right"
									style={{
										maxWidth: "9rem",
										fontSize: "small",
										fontWeight: "600",
									}}
								>
									{formatNumber(
										Object.keys(
											sumatoriaFinal.impuestos
										).reduce(
											(a, i) =>
												a +
												parseFloat(
													sumatoriaFinal.impuestos[i]
												),
											0
										)
									)}
								</div>
							</div>
						)} */}
					</div>
				</div>

				{/* {!isOriginal && factura.retencion && (
					<div className="m-t-15 m-b-15">
						Retención: {formatNumber(factura.retencion)}
					</div>
				)} */}

                {factura.direccion_entrega && (
					<>
						<p
							className="col-12 pl-0"
							style={{
								whiteSpace: "pre-line",
								lineHeight: "normal",
							}}
						>
							{factura.direccion_entrega.direccion}
						</p>
					</>
				)}

				{notas && (
					<>
						<p
							className="col-12 pl-0"
							style={{
								whiteSpace: "pre-line",
								lineHeight: "normal",
							}}
						>
							{notas}
						</p>
					</>
				)}

                {factura.plazo?.nombre !== 'Contado' && (
                    <div className="row justify-content-center mt-5">
                        <h3
                            className="col-10 text-center mr-0 fw-600 signature-title"
                            style={{ borderTop: "1px solid #000" }}
                        >
                            Elaborado por
                        </h3>
                        {/* <h3
                            className="col-10 text-center mt-5 mr-0 fw-600 signature-title"
                            style={{ borderTop: "1px solid #000" }}
                        >
                            Entregado Por
                        </h3> */}
                        <h3
                            className="col-10 text-center ml-0 fw-600 mt-5 signature-title"
                            style={{ borderTop: "1px solid #000" }}
                        >
                            Recibido por
                        </h3>
                        <hr style={{border: "1px dashed #ccc", width: "100%", marginTop: "15px"}} />
                    </div>
                )}

				{factura.plantilla?.pie_pagina && (
					<div
						className="col-12 pt-2 text-center d-flex justify-content-center"
						style={{
							fontWeight: "600",
						}}
					>
						<div className="text-center p-b-20">
							<small className="bold d-block">{factura.plantilla?.pie_pagina}</small>
						</div>
					</div>
				)}

                {factura.electronica && (
                    <div className="text-center">
                        <QR documento={factura.documento} size={120}/>
                    </div>
                )}
			</div>
		</>
	);
};

const DesktopLayout = ({
	factura,
	sucursal,
	sumatoriaFinal,
	status,
	isFactura = () => false,
	notas = "",
    direccion_entrega,
    totalImpuestos,
}) => {
	let isServicios = false;
	const cantidadProductos = factura?.productos?.reduce((c, a) => {
		if (a.producto.tipo === "servicio") {
			isServicios = true;
		}
		return a.cantidad + c;
	}, 0);

	return (
        <>
            <style>{`
                .invoice-desktop {
                    display: block;
                }
                .factura-logo {
                    max-height: 150px;
                    width: auto;
                }
                .pie-pagina {
                    font-family: "Saira Extra Condensed", sans-serif !important;
                }
                @media (min-width: 500px) {
                    .invoice-desktop {
                        font-family: "Poppins", sans-serif;
                        font-size: 12pt;
                    }
                }
                @media (max-width: 450px) {
                    .invoice-desktop {
                        display: none;
                    }
                }

                /* QR de ubicacion + caja de datos de la factura */
                .invoice-desktop .doc-bloque {
                    flex-shrink: 0;
                    align-items: center;
                    gap: 12px;
                }
                .invoice-desktop .doc-qr {
                    flex-shrink: 0;
                    line-height: 0;
                }
                .invoice-desktop .doc-identidad {
                    width: 260px;
                    flex-shrink: 0;
                }
                .invoice-desktop .doc-identidad table {
                    width: 100%;
                }
                .invoice-desktop .doc-identidad td {
                    padding: 0;
                    vertical-align: top;
                    line-height: 20px;
                }
                .invoice-desktop .doc-identidad__status {
                    text-align: right;
                    text-transform: uppercase;
                    letter-spacing: 0.08em;
                    font-size: 0.75rem;
                    line-height: 1.4;
                }
                .invoice-desktop .doc-identidad__tipo {
                    text-align: right;
                    font-weight: 600;
                    font-size: 0.95rem;
                    line-height: 1.3;
                    padding-bottom: 4px;
                    margin-bottom: 4px;
                    border-bottom: 1px solid #ccc;
                    text-transform: uppercase;
                }
                .invoice-desktop .doc-identidad__ncf {
                    font-family: "Courier New", Courier, monospace;
                    font-weight: 600;
                    font-size: 1.05rem;
                    white-space: nowrap;
                }

                /* Fila de informacion: cliente | condiciones */
                .invoice-desktop .info-row {
                    align-items: stretch;
                    border-top: 1px solid #ccc;
                }

                /* Tabla maestra para repetir el encabezado de cliente en cada pagina impresa */
                .invoice-desktop .invoice-main-table {
                    width: 100%;
                    border-collapse: collapse;
                }
                .invoice-desktop .invoice-main-table thead {
                    display: table-header-group;
                }
                .invoice-desktop .invoice-main-table tbody {
                    display: table-row-group;
                }
                .invoice-desktop .info-block--cliente {
                    flex: 1;
                    min-width: 0;
                    width: auto;
                }
                .invoice-desktop .info-block--condiciones {
                    width: 31%;
                    flex-shrink: 0;
                    padding-left: 12px;
                }
                .invoice-desktop .info-block--cliente td,
                .invoice-desktop .info-block--condiciones td {
                    font-size: 1rem !important;
                    line-height: 20px !important;
                }


                @media print and (min-width: 500px) {
                    .invoice.invoice-desktop.recibo-print table {
                        z-index: auto;
                        background-color: transparent;
                    }

                    .invoice-desktop {
                        display: block !important;
                        min-height: 0 !important;
                        height: auto !important;
                    }

                    .invoice-desktop .footer-facturas {
                        position: static !important;
                        margin-top: 30px;
                    }

                    .invoice-desktop .table-title,
                    .invoice-desktop .table-title::before,
                    .invoice-desktop .table-title::after {
                        display: none !important;
                        content: none !important;
                    }

                    .invoice-desktop .invoice-main-table::before,
                    .invoice-desktop .invoice-main-table::after,
                    .invoice-desktop .invoice-main-table *::before,
                    .invoice-desktop .invoice-main-table *::after {
                        content: none !important;
                        display: none !important;
                    }
                }
            `}</style>
            {factura.estado === 'cancelada' && (<>
                <div style={{
                    fontSize: '100px',
                    fontWeight: 'bold',
                    color: 'rgba(0,0,0,0.1)',
                    position: 'fixed',
                    top: '20%',
                    left: '45%',
                    zIndex: 2000,
                    transform: 'rotate(-45deg) translate(-50%, -50%)',
                }}>
                    CANCELADA
                </div>
            </>)}
            <div className="invoice invoice-desktop recibo-print">
                <div className="clear-both p-t-30 p-b-10 d-flex justify-content-between align-items-end">
                    <div className="sucursal-info">
                        {sucursal.logo ? (
                            <img
                                alt="logo"
                                className="mb-2 factura-logo"
                                src={sucursal.logo[0].url}
                                width="270px"
                            />
                        ) : factura.logo ? (
                            <img
                                alt="logo"
                                className="mb-2 factura-logo"
                                src={factura.logo[0].url}
                                width="270px"
                            />
                        ) : (
                            <h3 style={{ lineHeight: "12px", marginBottom: "3px" }}>
                                {sucursal.nombre}
                            </h3>
                        )}
                        <div
                            className="mb-0 mb-md-0"
                            style={{ lineHeight: "15px", fontSize: "13px" }}
                        >
                            RNC: {sucursal.rnc} TEL.:{sucursal.telefono}
                        </div>
                        <div
                            className="mb-2 mb-md-0"
                            style={{ lineHeight: "15px", fontSize: "13px" }}
                        >
                            {sucursal.direccion}
                        </div>
                    </div>

                    <div className="doc-bloque d-none d-md-flex">
                        {factura.cliente?.direcciones?.length > 0 && factura.qr && (
                            <div className="doc-qr">
                                <QR
                                    documento={{ documentStampUrl: factura.qr }}
                                    size={90}
                                />
                            </div>
                        )}
                        <div className="doc-identidad">
                        <div className="doc-identidad__status">{status}</div>
                        {!factura.numeracion?.isProforma && (
                            <div className="doc-identidad__tipo">
                                {isFactura(factura)
                                    ? factura.numeracion?.nombre
                                    : factura.numero_comprobante
                                    ? `Factura NO. ${factura.numero_comprobante.substring(
                                          factura.numero_comprobante.length - 5
                                      )}`
                                    : "Factura"}
                            </div>
                        )}
                        {factura.numeracion?.isProforma && (
                            <div className="doc-identidad__tipo">
                                Orden de Compra
                            </div>
                        )}
                        <table>
                            <tbody>
                                {factura.fecha && (
                                    <tr>
                                        <td className="text-right">
                                            <strong>Fecha: </strong>
                                            {dayjs(factura.fecha).format(
                                                "DD/MM/YYYY"
                                            )}
                                        </td>
                                    </tr>
                                )}
                                {!factura.numeracion?.isProforma && (
                                    <tr>
                                        <td className="text-right" colSpan="2"><small>{factura.numeracion?.nombre}</small></td>
                                    </tr>
                                )}
                                {factura.numero_comprobante && (
                                    <tr>
                                        <td className="text-right">
                                            <strong>
                                                {factura.numeracion?.isProforma
                                                    ? "No.: "
                                                    : "NCF: "}
                                            </strong>
                                            {factura.numeracion?.isProforma
                                                ? `OC${factura.numero_comprobante.substring(
                                                      factura.numero_comprobante.length - 5
                                                  )}`
                                                : factura.numero_comprobante}
                                        </td>
                                    </tr>
                                )}
                                {factura.numeracion?.fecha_vencimiento && (
                                    <tr>
                                        <td className="text-right">
                                            <small>
                                                <strong>FV: </strong>
                                                {dayjs(
                                                    factura.numeracion?.fecha_vencimiento
                                                ).format("DD/MM/YYYY")}
                                            </small>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        </div>
                    </div>
                </div>

                <div className="info-cliente-responsive d-block d-md-none">
                    {factura.cliente && (
                        <div className="row">
                            <div className="col-4 text-right px-1">
                                <span className="client-info-title">Cliente:</span>
                            </div>
                            <div className="col-7" style={{ lineHeight: "13px" }}>
                                {factura.cliente?.codigo} - {factura.cliente?.nombre}
                            </div>
                        </div>
                    )}
                    {factura.cliente?.identificacion && (
                        <div className="row">
                            <div className="col-4 text-right px-1">
                                <span className="client-info-title">
                                    RNC/Cédula:
                                </span>
                            </div>
                            <div className="col-7" style={{ lineHeight: "13px" }}>
                                {factura.cliente?.identificacion}
                            </div>
                        </div>
                    )}
                    {factura.cliente?.encargado && (
                        <div className="row">
                            <div className="col-4 text-right px-1 client-info-title">
                                Responsable:
                            </div>
                            <div className="col-7" style={{ lineHeight: "13px" }}>
                                {factura.cliente?.encargado}
                            </div>
                        </div>
                    )}
                    {factura.cliente?.telefono && (
                        <div className="row">
                            <div className="col-4 text-right px-1">
                                <span className="client-info-title">Teléfono:</span>
                            </div>
                            <div className="col-7" style={{ lineHeight: "13px" }}>
                                {factura.cliente?.telefono}
                            </div>
                        </div>
                    )}
                    {factura.cliente?.direcciones && factura.cliente?.direcciones?.length > 0 && (
                        <div className="row">
                            <div className="col-4 text-right px-1">
                                <span className="client-info-title">
                                    Dirección:
                                </span>
                            </div>
                            <div className="col-7" style={{ lineHeight: "13px" }}>
                                {factura.cliente?.direcciones[0].direccion}
                            </div>
                        </div>
                    )}
                    {factura.vendedor?.nombre && (
                        <div className="row">
                            <div className="col-4 text-right px-1">
                                <span className="client-info-title">Vendedor:</span>
                            </div>
                            <div className="col-7">
                                {limitVendedorFullName(
                                    factura.vendedor?.nombre,
                                    factura.vendedor?.apellido
                                )}
                            </div>
                        </div>
                    )}
                </div>

                <table className="invoice-main-table" width="100%">
                    <thead>
                        <tr>
                            <td style={{ verticalAlign: "top", padding: 0 }} colSpan={9}>
                                <div className="clear-both info-row p-t-10 p-b-10 d-none d-md-flex">
                                    <div className="info-block info-block--cliente">
                                        <table>
                                            <tbody>
                                                {factura.cliente?.nombre && (
                                                    <tr>
                                                        <td
                                                            width="120px"
                                                            className="client-info-title text-uppercase"
                                                        >
                                                            Cliente:
                                                        </td>
                                                        <td
                                                            style={{
                                                                lineHeight: "13px",
                                                                paddingLeft: "10px",
                                                            }}
                                                        >
                                                            {factura.cliente?.codigo} - {factura.cliente?.nombre}
                                                        </td>
                                                    </tr>
                                                )}
                                                {factura.cliente?.identificacion && (
                                                    <tr>
                                                        <td className="client-info-title text-uppercase">
                                                            RNC/Cédula:
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            {factura.cliente?.identificacion}
                                                        </td>
                                                    </tr>
                                                )}
                                                {factura.cliente?.encargado && (
                                                    <tr>
                                                        <td className="client-info-title text-uppercase">
                                                            Responsable:
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            {factura.cliente?.encargado}
                                                        </td>
                                                    </tr>
                                                )}
                                                {factura.cliente?.telefono && (
                                                    <tr>
                                                        <td className="client-info-title text-uppercase">
                                                            Teléfono:
                                                        </td>
                                                        <td style={{ paddingLeft: "10px" }}>
                                                            {factura.cliente?.telefono}
                                                        </td>
                                                    </tr>
                                                )}
                                                {factura.cliente?.direcciones && factura.cliente?.direcciones?.length > 0 && (
                                                    <tr>
                                                        <td className="client-info-title text-uppercase">
                                                            Dirección:
                                                        </td>
                                                        <td
                                                            style={{
                                                                lineHeight: "13px",
                                                                paddingLeft: "10px",
                                                            }}
                                                        >
                                                            {factura.cliente?.direcciones[0].direccion}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="info-block info-block--condiciones">
                                        <table>
                                            <tbody>
                                                {getDiasPlazo(
                                                    factura.fecha,
                                                    factura.fecha_vencimiento
                                                ) > 0 ? (
                                                    <tr>
                                                        <td className="client-info-title text-uppercase text-right">
                                                            Plazo:
                                                        </td>
                                                        <td className="text-right" style={{ paddingLeft: "10px" }}>
                                                            {getDiasPlazo(
                                                                factura.fecha,
                                                                factura.fecha_vencimiento
                                                            ) || 0}{" "}
                                                            días
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <tr>
                                                        <td className="client-info-title text-uppercase text-right">
                                                            Plazo:
                                                        </td>
                                                        <td className="text-right" style={{ paddingLeft: "10px" }}>
                                                            <span className="uppercase">{factura.plazo?.nombre || 'CONTADO'}</span>
                                                        </td>
                                                    </tr>
                                                )}
                                                {factura.tipo === "contado" &&
                                                factura.estado === "pendiente" ? (
                                                    <tr>
                                                        <td className="client-info-title text-uppercase text-right">
                                                            Estado:
                                                        </td>
                                                        <td className="text-right" style={{ paddingLeft: "10px" }}>
                                                            Pendiente
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    factura.tipo === "contado" &&
                                                    factura.estado === "cancelada" && (
                                                        <tr>
                                                            <td className="client-info-title text-uppercase">
                                                                Estado:
                                                            </td>
                                                            <td className="text-right" style={{ paddingLeft: "10px" }}>
                                                                Cancelada
                                                            </td>
                                                        </tr>
                                                    )
                                                )}

                                                {factura.estado === "pagada" && (
                                                    <>
                                                        {obtenerMetodosPago(
                                                            factura
                                                        ).map(
                                                            (metodo, idx) => (
                                                                <tr
                                                                    key={
                                                                        metodo.tipo_pago +
                                                                        idx
                                                                    }
                                                                >
                                                                    <td
                                                                        className="client-info-title text-uppercase text-right"
                                                                        style={{
                                                                            whiteSpace:
                                                                                "nowrap",
                                                                        }}
                                                                    >
                                                                        {idx === 0
                                                                            ? "Método de pago:"
                                                                            : ""}
                                                                    </td>
                                                                    <td
                                                                        className="text-right"
                                                                        style={{
                                                                            paddingLeft:
                                                                                "10px",
                                                                            textTransform:
                                                                                "capitalize",
                                                                        }}
                                                                    >
                                                                        {metodo.tipo_pago ===
                                                                        "nota_credito"
                                                                            ? "NOTA DE CREDITO"
                                                                            : metodo.tipo_pago}
                                                                        {metodo.monto > 0
                                                                            ? ` - ${formatCurrency(
                                                                                    metodo.monto,
                                                                                    "$"
                                                                                )}`
                                                                            : ""}
                                                                    </td>
                                                                </tr>
                                                            )
                                                        )}
                                                    </>
                                                )}

                                                {factura.vendedor?.nombre && (
                                                    <tr>
                                                        <td className="client-info-title text-uppercase text-right">
                                                            Vendedor:
                                                        </td>
                                                        <td className="text-right" style={{ paddingLeft: "10px" }}>
                                                            {limitVendedorFullName(
                                                                factura.vendedor?.nombre,
                                                                factura.vendedor?.apellido
                                                            )}
                                                        </td>
                                                    </tr>
                                                )}

                                                {factura.estado === "procesando" && factura.detalle_metodo_pago?.num_cheque && (<>
                                                    <tr>
                                                        <td className="client-info-title text-uppercase text-right">
                                                            Metodo de pago:
                                                        </td>
                                                        <td className="text-right" style={{ paddingLeft: "10px" }}>
                                                            CHEQUE {factura.estado?.toUpperCase()}
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                    <td className="client-info-title text-uppercase text-right">
                                                            
                                                        </td>
                                                        <td className="text-right" style={{ paddingLeft: "10px" }}>
                                                            No.{factura.detalle_metodo_pago.num_cheque}
                                                        </td>
                                                    </tr>
                                                </>)}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </td>
                        </tr>

                        <tr className="text-uppercase">
                            <th width="12%">Código/Ref.</th>
                            <th width="25%">Descripción</th>
                            <th width="8%">Cantidad</th>
                            <th width="8%">Unidad</th>
                            <th>Importe</th>
                            <th>Impuesto</th>
                            <th>Precio</th>
                            {factura.descuento > 0 && <th>Descuento</th>}
                            <th>Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        

                        {factura?.productos?.map((producto) => {
                            const descuento =
                                producto.cantidad *
                                (producto.importe +
                                    producto.importe *
                                        producto.impuesto?.porcentaje) *
                                (producto.descuento / 100);

                            const descuentoReal =
                                (producto.importe *
                                (producto.descuento / 100))
                                * producto.cantidad;

                            // Facturado por empaque: cuánto trae ese empaque, junto al nombre.
                            const contenidoEmpaque = contenidoEmpaqueDeLinea(producto);
                            return (
                                <tr key={producto.id}>
                                    <td>
                                        <div style={{ lineHeight: 1.2 }}>
                                            <div>
                                                {producto.producto?.referencia}
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        {producto.producto?.nombre}
                                        {contenidoEmpaque && ` (${contenidoEmpaque})`}
                                        {producto.producto.tipo === 'grupo' && producto.producto.componentes && (
                                            <>
                                                {producto.producto.componentes.map(componente => (
                                                    <small className="d-block text-muted">
                                                        {componente.componente.referencia} - {componente.componente.nombre} ({componente.cantidad})
                                                    </small>
                                                ))}
                                            </>
                                        )}
                                    </td>
                                    <td>{producto.cantidad}</td>
                                    <td>{unidadDeLinea(producto)}</td>
                                    <td>
                                        {formatCurrency(producto.importe, "$")}
                                    </td>
                                    <td style={{ whiteSpace: "nowrap" }}>
                                        {Object.keys(sumatoriaFinal.impuestos)
                                            .length > 1 && (
                                            <span className="fw-600">
                                                {tipoITBIS(producto.impuesto)}{" "}
                                            </span>
                                        )}
                                        {formatCurrency(
                                            producto.precio_facturado - producto.importe
                                        )}
                                    </td>
                                    <td>
                                        {formatCurrency(
                                            producto.total / producto.cantidad
                                        )}
                                    </td>
                                    {factura.descuento > 0 && (
                                        <td>{formatCurrency(descuentoReal)}</td>
                                    )}
                                    <td>
                                        {formatCurrency(producto.total - descuento)}
                                    </td>
                                </tr>
                            );
                        })}
                        {!isServicios && (
                            <tr>
                                <td></td>
                                <td></td>
                                <td>{cantidadProductos}</td>
                                <td colSpan="42"></td>
                            </tr>
                        )}
                    </tbody>
                </table>

                <div className="flex justify-content-between" style={{width: "100%"}}>
                    {Object.keys(sumatoriaFinal.impuestos).length > 1 && (
                        <div>
                            <div
                                style={{
                                    lineHeight: "16px",
                                    fontSize: "14px",
                                }}
                                className="mt-3 mb-3"
                            >
                                {Object.keys(sumatoriaFinal.impuestos).includes(
                                    "Itbis 16%"
                                ) && (
                                    <>
                                        <span>
                                            Items con I1 son gravados con 16% ITBIS
                                        </span>
                                        <br />
                                    </>
                                )}
                                {Object.keys(sumatoriaFinal.impuestos).includes(
                                    "Itbis 18%"
                                ) && (
                                    <span>Items con I2 son gravados con 18% ITBIS</span>
                                )}
                            </div>
                    </div>
                    )}
                    <div className="summary">
                        {!isOriginal && factura.retencion && (
                            <span className="srow">
                                <strong>Retención:</strong>
                                <span className="svalue">
                                    {formatCurrency(factura.retencion)}
                                </span>
                                <br />
                            </span>
                        )}
                        {factura.descuento > 0 && (
                            <span className="srow">
                                <strong>Descuento</strong>
                                <span className="svalue">
                                    -{formatCurrency(factura.descuento)}
                                </span>
                                <br />
                            </span>
                        )}
                        <span className="srow">
                            <strong>Subtotal</strong>
                            <span className="svalue">
                                {formatCurrency(factura.subtotal)}
                            </span>
                            <br />
                        </span>
                        {sumatoriaFinal?.exentoGrabado?.Exento &&
                            Object.keys(sumatoriaFinal.exentoGrabado).map(
                                (impuesto, index) => {
                                    return (
                                        <span className="srow" key={index}>
                                            <strong>{impuesto}</strong>
                                            <span className="svalue">
                                                {formatCurrency(
                                                    sumatoriaFinal.exentoGrabado[
                                                        impuesto
                                                    ],
                                                    "$"
                                                )}
                                            </span>
                                            <br />
                                        </span>
                                    );
                                }
                            )}
                        {Object.keys(sumatoriaFinal.impuestos).map(
                            (impuesto, index) => {
                                return (
                                    <span className="srow" key={index}>
                                        <strong>{impuesto}</strong>
                                        <span className="svalue">
                                            {formatCurrency(
                                                factura.sumatoria ? factura.sumatoria[impuesto.toUpperCase()] : sumatoriaFinal.impuestos[impuesto],
                                                "$"
                                            )}
                                        </span>
                                        <br />
                                    </span>
                                );
                            }
                        )}

                        {Object.keys(sumatoriaFinal.impuestos).length > 1 && (
                            <div className="srow mb-3">
                                <strong>
                                    Total Impuestos:
                                </strong>
                                <span className="svalue">
                                    {formatCurrency(
                                        Object.keys(sumatoriaFinal.impuestos).reduce(
                                            (a, i) =>
                                                a +
                                                parseFloat(sumatoriaFinal.impuestos[i]),
                                            0
                                        )
                                    )}
                                </span>
                            </div>
                        )}

                        {!isOriginal &&
                            factura.descuentoExtra > 0 && (
                                <span className="srow">
                                    <strong>Descuento Nota de Crédito</strong>
                                    <span className="svalue">
                                        {formatCurrency(factura.descuentoExtra)}
                                    </span>
                                    <br />
                                </span>
                            )}
                        <span className="srow">
                            <strong>TOTAL FACTURADO</strong>
                            <strong className="svalue">
                                {formatCurrency(
                                    factura.total -
                                        (isOriginal ? 0 : factura.descuentoExtra)
                                )}
                            </strong>
                            <br />
                        </span>

                        {!isOriginal &&
                            factura.porCobrar > 0 &&
                            factura.porCobrar <
                                factura.total - factura.descuentoExtra && (
                                <span className="srow">
                                    <strong>TOTAL ABONADO</strong>
                                    <span className="svalue">
                                        {formatCurrency(
                                            factura.total -
                                                factura.descuentoExtra -
                                                factura.porCobrar,
                                            "$"
                                        )}
                                    </span>
                                    <br />
                                    <strong>TOTAL PENDIENTE</strong>
                                    <span className="svalue">
                                        {formatCurrency(factura.porCobrar, "$")}
                                    </span>
                                    <br />
                                </span>
                            )}
                    </div>
                </div>

                {Object.keys(sumatoriaFinal.impuestos).length > 1 && (
                    <hr className="mb-0" />
                )}

                <hr className="d-block d-md-none mt-0" />
                {factura.direccion_entrega?.direccion && (
                    <>
                        <p style={{ fontWeight: "600", fontSize: "1rem" }}>
                            Dirección Entrega:
                        </p>
                        <p
                            className="col-12 col-md-8 pl-0 mb-3"
                            style={{
                                fontSize: "1rem",
                                whiteSpace: "pre-line",
                                lineHeight: "normal",
                            }}
                        >
                            {factura.direccion_entrega.direccion}
                        </p>
                    </>
                )}

                {notas && (
                    <>
                        <p style={{ fontWeight: "600", fontSize: "1rem" }} className="mt-3">
                            Notas:
                        </p>
                        <p
                            className="col-12 col-md-8 pl-0 mb-3"
                            style={{
                                fontSize: "1rem",
                                whiteSpace: "pre-line",
                                lineHeight: "normal",
                            }}
                        >
                            {notas}
                        </p>
                    </>
                )}

                <div className="footer-facturas row">
                    {factura.documento && (
                        <div className="col-12 col-md-3">
                            <QR documento={factura.documento} />
                        </div>
                    )}
                    <div className="col">
                        <div className="row justify-content-center align-items-end mt-5">
                            <div className="col-10 col-md-3 d-flex flex-column">
                                {factura.sello?.at(0)?.url && <img src={factura.sello.at(0)?.url} style={{maxHeight: "92px", maxWidth: "100%", margin: "auto"}} />}
                                {factura.firma?.at(0)?.url && <img src={factura.firma.at(0)?.url} style={{maxHeight: "92px", maxWidth: "100%", margin: "auto"}} />}

                                <h3
                                    className="text-center mr-md-2 mr-0 fw-600 signature-title"
                                    style={{ borderTop: "1px solid #000" }}
                                >
                                    Elaborado por
                                </h3>
                            </div>


                            <div className="col-md-1 d-none d-md-block"></div>
                            <h3
                                className="col-10 col-md-3 text-center mr-md-2 mr-0 mt-md-4 fw-600 signature-title"
                                style={{ borderTop: "1px solid #000" }}
                            >
                                Entregado Por
                            </h3>
                            <div className="col-md-1 d-none d-md-block"></div>
                            <h3
                                className="col-10 col-md-3 text-center ml-md-2 ml-0 fw-600 mt-5 mt-md-4 signature-title"
                                style={{ borderTop: "1px solid #000" }}
                            >
                                Recibido por
                            </h3>
                        </div>
                        {factura.plantilla?.pie_pagina && (
                            <div
                                className="col-12 pt-5 text-center d-flex justify-content-center"
                                style={{
                                    fontWeight: "600",
                                    fontSize: "1rem",
                                    whiteSpace: "pre-line",
                                    lineHeight: "normal",
                                }}
                            >
                                <p className="text-center pie-pagina">
                                    {factura.plantilla?.pie_pagina}
                                </p>
                            </div>
                        )}
                    </div>
                </div>
</div>
        </>
	);
};

export default PrintSingleFacturaNew;
